import React from 'react';

import './styles.css';

const ChartLegend = ({segment: {label, value}}) => {
  const valueCSSClassName = value.split(' ').join('-');

  return (
    <div className="ChartLegend colab-centered">
      <div
        className={`ChartLegend__circle ChartLegend--${valueCSSClassName ||
          'unknown'}__circle`}
      />
      <div>{label}</div>
    </div>
  );
};

export default ChartLegend;
